<template>
    <div class="mb-2">
        <FileUpload 
            is-modal
            :title="$t('Add documents')"
            has-submit
            modal-name="folder-modal"
            file-upload
            @single-file="singleFileUpload"/>
        <div v-if="files.length" class="d-flex flex-column mt-2">
            <div v-for="(file, index) in files" :key="index" class="d-flex align-items-center">
                <DisplayFile :file-too-large="!fileSizeWithinLimit(file)" :display-file="file" :index="index" class="py-1" @reupload="reUpload(file)"/>
            </div>
        </div>
    </div>
</template>

<script>
import FileUpload from '@components/upload/FileUpload.vue';
import DisplayFile from '@components/DisplayFile.vue';
import {mapGetters} from 'vuex';
import EventBus from '@/utils/eventBus';

export default {
    name: 'FolderUpload',
    props: ['type'],
    data() {
        return {
            files: [],
            fileSizeMax: 200000000
        };
    },
    computed: {
        ...mapGetters([
            'currentEmployee',
            'currentGuardian',
            'userTargetGroups',
            'activeKindergartenId',
            'userTargetIdentities',
            'folder'
        ])
    },
    methods: {
        singleFileUpload(file) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('type', this.type);
            formData.append('uploaded_at', this.$moment().utc().format('YYYY-MM-DD HH:mm:ss.SSS'));
            
            this.files.push(file);
            const indexOfFIle = this.files.length - 1;

            this.$store.dispatch('UPLOAD_FILE', {form: formData, id: this.folder.id}).then( () => {
                this.sendStatusToChild(file, 'success', indexOfFIle);
            }).catch(() => {
                this.sendStatusToChild(file, 'catch', indexOfFIle);
            });
        },
        fileSizeWithinLimit(file) {
            return file.size <= this.fileSizeMax;
        },
        sendStatusToChild(file, status, index) {
            const data = {
                statusType: '',
                uploading: false
            };

            switch (status) {
            case 'success':
                data.statusType = 'success';
                data.color = 'text-success';
                break;
            case 'catch':
                data.statusType = 'danger';
                data.color = 'text-danger';
                break;
            default:
                break;
            }

            EventBus.emit(`${file.name}-${index}`, data);
        }
    },
    components: {
        FileUpload,
        DisplayFile
    }
};
</script>
